import {SortableContext, SortableContextProps} from '@dnd-kit/sortable';

import {buildSortableItemId} from '../utils/buildSortableItemId';

interface SortableWrapperProps extends SortableContextProps {
  children: React.ReactNode;
  containerId: string;
  items: {
    id: string;
    url: string;
  }[];
}

export const SortableWrapper = (props: SortableWrapperProps) => {
  const {children, containerId, items, ...rest} = props;

  return (
    <SortableContext
      {...rest}
      id={containerId}
      items={items?.map((item, index) =>
        buildSortableItemId(item.id, props.containerId, item.url, index)
      )}
    >
      {children}
    </SortableContext>
  );
};
